import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { wz } from '../../components/wizard-tokens';
import { WizGradientButton } from '../../components/wizard-ui';

interface Props {
  open: boolean;
  /** Echtes Tageslimit der Profilbesuche des Kontos. */
  limit: number;
  onClose: () => void;
}

/** Info, wenn alles, was heute möglich ist, analysiert ist und der Rest auf den nächsten Tag wartet (einmal pro Kampagne und Tag). */
const AnalysisLimitDialog: React.FC<Props> = ({ open, limit, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      <DialogTitle sx={{ fontSize: 20, fontWeight: 700 }}>{t('wizListLimitTitle')}</DialogTitle>
      <DialogContent sx={{ paddingTop: '8px !important' }}>
        <div style={{ fontSize: 15, color: wz.text }} data-testid="wiz-limit-body">
          {t('wizListLimitBody', { limit })}
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '0 24px 20px' }}>
        <WizGradientButton onClick={onClose}>{t('wizListLimitOk')}</WizGradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default AnalysisLimitDialog;
